import GenericGridCreator from 'ps-components/AdvancedTable/GenericGrid/GenericGridCreator';
import addAlert from 'ps-components/AlertToast/addAlert';
import { SurveyDetails } from 'ps-components/AdvancedTable/GenericGrid/GenericGridCellRenderers';

const SURVEY_LIBRARY_SET_ADVANCED_FILTERS = 'SURVEY_LIBRARY_SET_ADVANCED_FILTERS';
export const SURVEY_LIBRARY_CLEAR_ADVANCED_FILTERS = 'SURVEY_LIBRARY_CLEAR_ADVANCED_FILTERS';
const SURVEY_LIBRARY_SET_SEARCH_MODE = 'SURVEY_LIBRARY_SET_SEARCH_MODE';
const SURVEY_LIBRARY_CLEAR_SORT = 'SURVEY_LIBRARY_CLEAR_SORT';
const SURVEY_LIBRARY_GG_SEARCH_ERROR = 'SURVEY_LIBRARY_GG_SEARCH_ERROR';

const newGenericGrid = new GenericGridCreator(
  'SURVEY_LIBRARY',
  {},
  {
    addedFilters: [],
    searchMode: localStorage.getItem('survey-library__facet-panel_search_mode') === 'true' ? 'facet' : 'advanced',
    defaultLeftColumns: [
      {
        Header: 'Survey Job Matches',
        stickyLeft: true,
        customRender: SurveyDetails,
        width: 350,
        accessor: null
      }
    ],
    hiddenTerms: ['field_survey_code', 'field_job_code', 'field_job_scope', 'field_pub_survey_long_name']
  },
  {
    getInstanceState: store => store.landingPage.InternalJobsReducer.surveyLibraryGrid
  }
);
export const surveyLibraryGridActions = newGenericGrid.getActions();

surveyLibraryGridActions.setAdvancedFilters = (filters, localStorageKey) => {
  return dispatch => {
    const cleanedFilters = filters.filter(filter => filter.field && filter.operator && filter.value);
    if (cleanedFilters.length) cleanedFilters[0].canDelete = false;
    if (localStorageKey) localStorage.setItem(localStorageKey, JSON.stringify(cleanedFilters));
    return dispatch({
      type: SURVEY_LIBRARY_SET_ADVANCED_FILTERS,
      filters: cleanedFilters
    });
  };
};

surveyLibraryGridActions.clearAdvancedFilters = () => {
  return dispatch => {
    return dispatch({
      type: SURVEY_LIBRARY_CLEAR_ADVANCED_FILTERS
    });
  };
};

surveyLibraryGridActions.clearSort = () => {
  return dispatch => {
    return dispatch({
      type: SURVEY_LIBRARY_CLEAR_SORT
    });
  };
};

surveyLibraryGridActions.setSearchMode = mode => {
  return dispatch => {
    return dispatch({
      type: SURVEY_LIBRARY_SET_SEARCH_MODE,
      mode
    });
  };
};

function extendReducer(state, action) {
  switch (action.type) {
    case SURVEY_LIBRARY_SET_ADVANCED_FILTERS:
      return {
        ...state,
        addedFilters: action.filters
      };
    case SURVEY_LIBRARY_SET_SEARCH_MODE:
      return {
        ...state,
        searchMode: action.mode
      };
    case SURVEY_LIBRARY_CLEAR_ADVANCED_FILTERS:
      return {
        ...state,
        addedFilters: []
      };
    case SURVEY_LIBRARY_CLEAR_SORT:
      return {
        ...state,
        orderBy: []
      };
    case SURVEY_LIBRARY_GG_SEARCH_ERROR:
      return {
        ...state,
        data: [],
        tableProps: {
          ...state.tableProps,
          totalCount: 0,
          rowData: [],
          columnHeaders: [],
          noDataText: 'Error loading data',
          dataLoading: false
        },
        metadata: {
          ...state.metadata,
          totalCount: 0
        },
        loading: false,
        loaded: true
      };
    default:
      return null;
  }
}

export default newGenericGrid.createReducer(extendReducer);
